import { ServiceHandler } from '../../utils';

export const generateRiskReport = ServiceHandler({
  url: '/api/reports/v1/generateRiskReport',
  method: 'GET',
});

export const RUNNING = 'RUNNING';

type GetRiskReportDocInfoResponse = {
  docId: string;
  isScannerRunning: boolean;
  isReportGenerating: boolean;
  metadata: {
    generatedDate: string;
  };
};

export const getRiskReportDocInfo = ServiceHandler<
  unknown,
  GetRiskReportDocInfoResponse
>({
  url: '/api/reports/v1/riskReport',
  method: 'GET',
});
